import { CoreModule } from '@abp/ng.core';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeLeptonModule } from '@volo/abp.ng.theme.lepton';
import { CommercialUiModule, DateRangePickerModule } from '@volo/abp.commercial.ng.ui';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { DateFormatterPipe } from './pipes/date-formatter.pipe';
import { CreditFormatPipe } from './pipes/credit-format.pipe';
import { OrganizationUnitSelectorComponent } from './components/organization-unit-selector/organization-unit-selector.component';
import { FileDownloadHelperService } from './services/file-download-helper.service';
import { NavItemsComponent } from './components/nav-items/nav-items.component';
import { VersionInfoComponent } from './components/version-info/version-info.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomButtonComponent } from './components/custom-button/custom-button.component';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { TagMultiselectComponent } from './components/tag-multiselect/tag-multiselect.component';
import { FormsModule } from '@angular/forms';
import { FiltersCardComponent } from './components/filters-card/filters-card.component';
import { DatetimePickerModule } from './components/datetime-picker/datetime-picker.module';
import { DateRange } from '@angular/material/datepicker';
import { DatetimeRangePickerModule } from './components/datetime-range-picker/datetime-range-picker.module';
import { ColumnOptionsComponent } from './components/column-options/column-options.component';
import { BillingDatePipe, BillingPeriodRangePipe } from './pipes/billing-date.pipe';


@NgModule({
  declarations: [OrganizationUnitSelectorComponent, DateFormatterPipe, NavItemsComponent, VersionInfoComponent, CustomButtonComponent, CustomDropdownComponent, TagMultiselectComponent, FiltersCardComponent, ColumnOptionsComponent],
  imports: [
    CoreModule,
    CommonModule,
    ThemeSharedModule,
    ThemeLeptonModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    NgSelectModule,
    CommonModule,
    FormsModule,
    NgbCollapseModule,
    DatetimePickerModule,
    DatetimeRangePickerModule,
    CreditFormatPipe,
    BillingDatePipe,
    BillingPeriodRangePipe,
  ],
  exports: [
    CoreModule,
    ThemeSharedModule,
    ThemeLeptonModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    OrganizationUnitSelectorComponent,
    DateFormatterPipe,
    CustomButtonComponent,
    CustomDropdownComponent,
    TagMultiselectComponent,
    FiltersCardComponent,
    NgbCollapseModule,
    DatetimePickerModule,
    DatetimeRangePickerModule,
    CreditFormatPipe,
    ColumnOptionsComponent,
    BillingDatePipe,
    BillingPeriodRangePipe
  ],
  providers: [FileDownloadHelperService],
})
export class SharedModule {}
